<div class="topbar-search">
    <i class="uil uil-search topbar-search-icon" aria-hidden="true"></i>
    <input #input type="search" class="form-control" placeholder="Search titles, users, theaters"
        aria-label="Search titles, users, theaters, cast and streaming services" autocomplete="off" spellcheck="false"
        role="combobox" aria-autocomplete="list" aria-controls="topbar-search-results" [attr.aria-expanded]="open"
        [attr.aria-activedescendant]="active >= 0 ? 'topbar-search-result-' + active : null"
        (input)="didType(input.value)" (focus)="didFocus()" (blur)="didBlur()" (keydown)="onKeydown($event)" />
    <kbd class="topbar-search-key" *ngIf="!query" title="Press / to search">/</kbd>

    <!-- mousedown keeps the focus in the box, so the results do not close under the click -->
    <div class="topbar-search-results" id="topbar-search-results" role="listbox" *ngIf="open" (mousedown)="$event.preventDefault()">
        <p class="topbar-search-status" *ngIf="!groups.length">{{ loading ? 'Searching…' : 'Nothing found for “' + query.trim() + '”.' }}</p>

        <div *ngFor="let group of groups; trackBy: trackByType" role="group" [attr.aria-label]="group.label" [class.stale]="loading">
            <h6 class="topbar-search-heading">{{ group.label }}</h6>
            <a *ngFor="let result of group.results" class="topbar-search-result" [routerLink]="result.route" (click)="didClick($event)"
                [id]="'topbar-search-result-' + result.index" role="option" tabindex="-1"
                [class.active]="active === result.index" [attr.aria-selected]="active === result.index" (mousemove)="active = result.index">
                <span class="topbar-search-thumb" [ngClass]="'is-' + result.type">
                    <img *ngIf="result.image; else placeholder" [src]="result.image" alt="" loading="lazy" />
                    <ng-template #placeholder>
                        <i class="uil" [ngClass]="{ 'uil-film': result.type === 'title', 'uil-user': result.type === 'user',
                            'uil-map-marker': result.type === 'theater', 'uil-star': result.type === 'cast',
                            'uil-tv-retro': result.type === 'watch-now-service' }"></i>
                    </ng-template>
                </span>
                <span class="topbar-search-text">
                    <span class="topbar-search-name">
                        {{ result.name }}
                        <span *ngIf="result.badge" class="badge badge-soft-secondary ml-1">{{ result.badge }}</span>
                    </span>
                    <small *ngIf="result.detail">{{ result.detail }}</small>
                </span>
            </a>
        </div>
    </div>
</div>
